import {
  hexToRGB,
  MOON_350,
  RED_300,
  TABLET_BREAKPOINT_WIDTH,
  TEAL_500,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox, Dropdown} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

const flexRowStyles = `
  display: flex;
  align-items: center;
  align-content: center;
`;

export const ReportPageHeader = styled.div<{$isInEditMode?: boolean}>`
  ${flexRowStyles}
  justify-content: ${({$isInEditMode}) =>
    $isInEditMode ? 'space-between' : 'flex-end'};
  gap: 16px;
  padding: 12px 12px 12px 6px;

  ${({$isInEditMode}) =>
    $isInEditMode &&
    css`
      @media only screen and (max-width: ${TABLET_BREAKPOINT_WIDTH + 150}px) {
        flex-direction: column;
        align-items: flex-start;
      }
    `}

  // This is intentionally added, so the correct font is rendered in
  // fully connected for the report menu actions
  font-family: 'Source Sans Pro';
`;

export const FlexRow = styled.div`
  ${flexRowStyles}
`;

export const ReportActionsMenu = styled(Dropdown.Menu)`
  max-width: 196px;
`;

export const ReportActionsMenuItem = styled(Dropdown.Item)<{
  $applyMarginTop?: boolean;
  $applyMarginBottom?: boolean;
  $destructive?: boolean;
}>`
  display: flex !important;
  align-items: center;
  align-content: center;

  max-height: 36px;
  width: 184px;

  // padding that is being overriden is .8125rem 1.125rem!important
  // to add a hover state we have to increase margin and decrease padding
  margin-left: 0.5em !important;
  margin-right: 0.5em !important;
  &&&& {
    padding: 0.625em !important;
  }
  border-radius: 4px !important;

  ${props =>
    props.$applyMarginTop &&
    css`
      margin-top: 0.3125em !important;
    `}

  ${props =>
    props.$applyMarginBottom &&
    css`
      margin-bottom: 0.3125em !important;
    `}

  svg {
    margin-right: 8px;
  }

  p {
    margin: 0px;
    line-height: 22px;
  }

  ${props =>
    props.$destructive &&
    css`
      &:hover {
        background-color: ${hexToRGB(RED_300, 0.48)} !important;
      }
    `}
`;

export const ReportNotificationsToggle = styled(Checkbox).attrs({toggle: true})`
  transform: scale(0.7);

  &&&&& {
    label:before {
      background-color: ${p => (p.checked ? TEAL_500 : MOON_350)} !important;
    }
  }
`;
